<template>
  <div class="collection-component-container">
    <div class="tabs-item">
      <div class="tab-item" :class="page == 'list' ? 'active' : ''" @click="page = 'list'">工单列表</div>
      <div class="tab-item" :class="page == 'add' ? 'active' : ''" @click="page = 'add'">提交工单</div>
    </div>
    <contentGdListComponent v-if="page == 'list'" />
    <contentAddGdComponent v-if="page == 'add'" />
  </div>
</template>


<script>
import contentGdListComponent from './ContentGdListComponent.vue'
import contentAddGdComponent from './ContentAddGdComponent.vue';

export default {
  name: "ContentGdComponent",
  components: {
    contentGdListComponent,
    contentAddGdComponent,
  },
  data() {
    return {
      page: 'list'
    }
  },
  watch: {
    '$route'(val) {
      if (val.name == 'Content' && val.query.page) {
        this.page = val.query.page
      }
    }
  },
  mounted() {
    if (this.$route.query && this.$route.query.page) {
      this.page = this.$route.query.page
    }
  },
  methods: {
  }
}
</script>

<style lang="less" scoped>
.tabs-item {
  padding: 25px 0 20px;
  display: flex;
  align-items: center;
  .tab-item {
    cursor: pointer;
    width: 75px;
    height: 25px;
    display: flex;
    justify-content: center;
    align-items: center;
    background-color: #f5f7fa;
    color: #64748b;
    font-size: 12px;
    margin-right: 10px;
    border-radius: 13px;
    &.active {
      background-color: #5783fc;
      color: #fff;
    }
  }
}
</style>